var _rect, _circle, _rect2, _rect3, _circle2, _rect4, _rect5, _circle3, _rect6, _rect7, _circle4, _rect8, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyStats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 107,
    viewBox: "0 0 200 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 106.579,
    rx: 9.68904,
    fill: "#989D99"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9557,
    cy: 16.9557,
    r: 7.26678,
    fill: "#E5E5D6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.856,
    y: 9.68896,
    width: 29.0671,
    height: 5.45009,
    rx: 2.72504,
    fill: "#4C565D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.856,
    y: 18.7725,
    width: 162.455,
    height: 5.45009,
    rx: 2.72504,
    fill: "#E5E5D6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9557,
    cy: 41.1784,
    r: 7.26678,
    fill: "#E5E5D6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27.856,
    y: 33.9116,
    width: 29.0671,
    height: 5.45009,
    rx: 2.72504,
    fill: "#4C565D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 27.856,
    y: 42.9951,
    width: 162.455,
    height: 5.45009,
    rx: 2.72504,
    fill: "#E5E5D6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9557,
    cy: 65.4011,
    r: 7.26678,
    fill: "#E5E5D6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 27.856,
    y: 58.1343,
    width: 29.0671,
    height: 5.45009,
    rx: 2.72504,
    fill: "#4C565D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 27.856,
    y: 67.2178,
    width: 162.455,
    height: 5.45009,
    rx: 2.72504,
    fill: "#E5E5D6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9557,
    cy: 89.6237,
    r: 7.26678,
    fill: "#E5E5D6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 27.856,
    y: 82.3569,
    width: 29.0671,
    height: 5.45009,
    rx: 2.72504,
    fill: "#4C565D"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 27.856,
    y: 91.4404,
    width: 162.455,
    height: 5.45009,
    rx: 2.72504,
    fill: "#E5E5D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStats);
export default __webpack_public_path__ + "static/media/empty-stats.ce01a4bc1010db3a611ad705a0a55a8b.svg";
export { ForwardRef as ReactComponent };